//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'legal-document',
  components: {
    PrintButton: () => import('@motionelements/core/src/components/ui/buttons/PrintButton.vue'),
    AgreementContent: () => import('./AgreementContent.vue'),
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
};
